module.exports = __webpack_public_path__ + "media/images/pkg-pv-p-64eca42d54f6b999990539a23e3df617.svg";